import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const productsJsmFeatureUsageRoute: InvariantJiraRoute = {
	name: 'products-jsm-feature-usage',
	path: '/jira/settings/products/servicedesk/feature-usage',
	exact: true,
};
